module.exports = __webpack_public_path__ + "static/Image 105-80b657977279c700e5e42b1aa1b03458.png";